<template>
    <div>
        <div class="columns">
            <div class="column">
                <h2 class="title is-3">
                    Release log
                </h2>
                <div class="field is-grouped is-grouped-multiline">
                    <div
                        v-for="item in filterList"
                        class="control">
                        <div class="tags has-addons">
                            <span class="tag is-dark">{{ filterToName(item[0]) }}</span>
                            <span class="tag is-info">{{ item[1] }}</span>
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <b-dropdown>
                        <template #trigger>
                            <b-button
                                :label="`Number of results: ${selectedNumOfResults}`"
                                type="is-info"
                                icon-right="menu-down" />
                        </template>
                        <b-dropdown-item
                            v-for="num in numOfResults"
                            :key="num"
                            :value="num"
                            @click="onSelectedNumberOfResultsChanged(num)">
                            {{ num }}
                        </b-dropdown-item>
                    </b-dropdown>
                    <b-dropdown>
                        <template #trigger>
                            <b-button
                                :label="`LogLevel: ${selectedLogLevel}`"
                                type="is-info"
                                icon-right="menu-down" />
                        </template>
                        <b-dropdown-item
                            v-for="level in logLevels"
                            :key="level"
                            :value="level"
                            @click="onSelectedLogLevelChanged(level)">
                            {{ level }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>
        </div>

        <spinner
            v-if="loading"
            :loading="loading" />
        <b-table
            :data="log"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            detailed
            :has-detailed-visible="hasDetails">
            <b-table-column
                v-slot="props"
                field="logLevel"
                label="Level"
                sortable>
                <span :class="['tag', logLevelClasses[props.row.logLevel]]">
                    {{ props.row.logLevel }}
                </span>
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="timestamp"
                label="Timestamp (UTC)"
                sortable>
                {{ longDate(props.row.timestamp) }}
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="libraryName"
                label="Library"
                sortable>
                <router-link
                    v-if="props.row.libraryName"
                    :to="getLibraryLink(props.row.libraryName)">
                    {{ props.row.libraryName }}
                </router-link>
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="codeSetDescription"
                label="Set"
                sortable>
                <a
                    v-if="props.row.codeSetName"
                    :href="getCodeSetLink(props.row.codeSetName)">
                    {{ props.row.codeSetDescription }}
                </a>
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="releaseId"
                label="Release Id"
                sortable>
                <router-link :to="getReleaseLink(props.row.releaseId)">
                    {{ props.row.releaseId }}
                </router-link>
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="publishJobId"
                label="Job Id"
                sortable>
                {{ props.row.publishJobId }}
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="message"
                label="Message"
                sortable>
                {{ props.row.message }}
            </b-table-column>
            <template #detail="props">
                <pre>{{ props.row.data }}</pre>
            </template>
        </b-table>
    </div>
</template>
<script>
    import Spinner from '@/shared/components/Spinner.vue';
    import { getLogs } from '@/shared/helpers/api';
    import { getCodeSetLink, getLibraryLink, getReleaseLink } from '@/shared/helpers/routing';
    import loadash from 'lodash';
    import { longDate } from '@/formatters.ts';

    export default {
        components: {
            Spinner
        },
        data: () => {
            return {
                log: [],
                loading: true,
                filterList: [],
                selectedNumOfResults: 100,
                numOfResults: [10, 50, 100, 500, 1000, 5000],
                selectedLogLevel: 'Info',
                logLevels: ['Info', 'Warning', 'Error']
            };
        },
        computed: {
            logLevelClasses() {
                return { 'Error': 'is-danger', 'Info': 'is-info', 'Warning': 'is-warning' };
            }
        },
        mounted() {
            this.load();
        },
        methods: {
            longDate,
            async load() {
                this.loading = true;
                const f = this.filter();

                this.filterList = loadash.toPairs(f.params);
                f.params['limit'] = this.selectedNumOfResults;
                f.params['logLevel'] = this.selectedLogLevel;
                this.log = await getLogs(this, f);
                this.loading = false;
            },
            filter() {
                // TODO: window.location.search is empty
                const queryParams = new URLSearchParams(window.location.search);
                const filter = { params: {} };

                loadash.each(['libraryName', 'codeSetName', 'releaseId', 'publishJobId', 'applicationName'], function(elm) {
                    const tmp = queryParams.get(elm);
                    if (tmp)
                        filter.params[elm] = tmp;
                });
                return filter;
            },
            hasDetails(row) {
                return row.data;
            },
            async onSelectedNumberOfResultsChanged(number) {
                this.selectedNumOfResults = number;
                await this.load();
            },
            async onSelectedLogLevelChanged(level) {
                this.selectedLogLevel = level;
                await this.load();
            },
            filterToName(inValue) {
                switch (inValue) {
                    case 'libraryName': return 'Library';
                    case 'codeSetName': return 'Library set';
                    case 'releaseId': return 'Release';
                    case 'publishJobId': return 'Publish job';
                    case 'applicationName': return 'Application';
                    default: return inValue;
                }
            },
            getCodeSetLink,
            getReleaseLink,
            getLibraryLink
        }
    };
</script>
